import React from "react";
import { Col, Form, Row } from "react-bootstrap";
import { CCAssessmentType } from "../../Physician/Models/CCEnrollment";
import CcAssessmentPathwayEnrollment from "../Models/CcAssessmentPathwayEnrollment";

interface IProps{
    pathwayEnrollment: CcAssessmentPathwayEnrollment;
}
export default function ArticleRequirementPreview(props: IProps){

    const getAbccCertifications = () => {
        return props.pathwayEnrollment.ccEnrollmentCertificates.filter(_ => _.isEnrolled && _.isAbccEligible && _.ccAssessmentType == CCAssessmentType.Article);
    }

    const getTotalArticlesRequired = () =>{
        var totalRequired = 0;
        totalRequired = totalRequired + (getAbccCertifications().length * props.pathwayEnrollment.articlePathwayPerCertificationMinimum);
        return totalRequired;
    }

    if (getAbccCertifications().length == 0) return (<React.Fragment></React.Fragment>);
    return (
        <React.Fragment>
            <div className="pp-assessment-review-section">
            <p className="font-weight-bold">ABCC Requirements</p>
            <Form.Group>
                <p>The following summarizes the article exam requirements that will be required in each 3 year block.</p>
            </Form.Group>
            <Form.Group>
                <Col>
                    <Row className="pp-assessment-review-item">
                        <Col><strong>Certification</strong></Col>
                        <Col><strong>Article Exams Required</strong></Col>
                    </Row>
                    {props.pathwayEnrollment.ccEnrollmentCertificates && 
                        getAbccCertifications().map(abccCert => 
                            <Row key={abccCert.certificateId} className="pp-assessment-review-item">
                                <Col className="pp-assessment-review-item-col">{abccCert.certificationName}</Col>
                                <Col className="pp-assessment-review-item-col">{props.pathwayEnrollment.articlePathwayPerCertificationMinimum}</Col>
                            </Row>
                    )}
                    <Row className="pp-assessment-review-item">
                        <Col className="font-weight-bold">Total</Col>
                        <Col className="pp-assessment-review-item-footer-col"><strong>{getTotalArticlesRequired()}</strong></Col>
                    </Row>
                </Col>
            </Form.Group>
            
            </div>
        </React.Fragment>
    );
}